<section class="scheda-wrap px-container pb-16">

    <div class="scheda-title-strip">
        <h2>{{ evento?.evento || 'Area Compagnia' }}</h2>
        <span class="meta">
            {{ evento?.dal | date: 'dd MMMM yyyy' }}
            @if (evento?.al && evento?.dal !== evento?.al) {
                — {{ evento?.al | date: 'dd MMMM yyyy' }}
            }
            · {{ evento?.ragione_sociale }}
        </span>
    </div>

    <form [formGroup]="formEvento" (ngSubmit)="onSubmit()">

        <!-- SEGNALAZIONI -->
        <section class="sec segnalazioni" [class.collapsed]="!openSections['segnalazioni']">
            <div class="sec-head" [class.warn]="!!notePending" [class.ok]="!notePending && noteInviate.length" [class.empty]="!notePending && !noteInviate.length" (click)="toggleSec('segnalazioni')">
                <h3>Segnalazioni</h3>
                <span class="stato-mini" [class.warn]="!!notePending" [class.ok]="!notePending && noteInviate.length" [class.empty]="!notePending && !noteInviate.length">
                    {{ notePending ? 'bozza da inviare' : (noteInviate.length ? (noteInviate.length + ' inviate') : 'nessuna') }}
                </span>
                <span class="toggle">▾</span>
            </div>
            <div class="sec-body">
                <div class="ac-note-box" style="margin-top:0">
                    <label>Nota per la compagnia</label>
                    <p class="ac-note-hint">Puoi salvare una bozza oppure inviare direttamente: all’invio viene usato il testo attuale.</p>
                    <textarea pInputTextarea rows="5" [(ngModel)]="notaDraft" [ngModelOptions]="{standalone: true}" placeholder="Es. mancano documenti del personale X, POS della ditta Y, scheda tecnica da aggiornare…"></textarea>
                    <div class="ac-note-actions">
                        <button type="button" class="acc-btn" [disabled]="!(notaDraft || '').trim()" (click)="onSaveNota()">
                            {{ notePending ? 'Aggiorna bozza' : 'Salva bozza' }}
                        </button>
                        @if (notePending) {
                            <button type="button" class="acc-btn acc-btn-ghost" (click)="onDeleteNota(notePending.id)">Elimina bozza</button>
                        }
                        @if (notePending || (notaDraft || '').trim()) {
                            <button type="button" class="acc-btn acc-btn-primary" [disabled]="invioNoteLoading || !(notaDraft || '').trim()" (click)="onInviaSegnalazioni()">
                                Invia alla compagnia
                            </button>
                        }
                    </div>
                    @if (noteInviate.length) {
                        <div class="ac-note-history">
                            <label>Storico invii</label>
                            @for (n of noteInviate; track n.id) {
                                <div class="ac-note-item sent">
                                    <div class="ac-note-text">{{ n.testo }}</div>
                                    <div class="ac-note-meta">inviata · {{ n.inviata_at | date: 'dd/MM/yy HH:mm' }}</div>
                                </div>
                            }
                        </div>
                    }
                </div>
            </div>
        </section>

        <!-- §1 EVENTO E COMPAGNIA -->
        <section class="sec dossier" [class.collapsed]="!openSections['dossier']">
            <div [ngClass]="secStato('dossier').cls" class="sec-head" (click)="toggleSec('dossier')">
                <h3>Evento e Compagnia/Organizzatore</h3>
                <span class="stato-mini" [ngClass]="secStato('dossier').cls">{{ secStato('dossier').text }}</span>
                <span class="toggle">▾</span>
            </div>
            <div class="sec-body">
                <div class="fld">
                    <label>Compila da rubrica</label>
                    <p-dropdown
                        styleClass="w-full"
                        panelStyleClass="ac-filter-panel"
                        [options]="rubricaCompagnie"
                        [(ngModel)]="rubricaCompagniaSel"
                        [ngModelOptions]="{standalone: true}"
                        optionLabel="ragione_sociale"
                        [showClear]="true"
                        [filter]="true"
                        filterBy="ragione_sociale,piva,sede"
                        placeholder="Cerca ragione sociale o P.IVA…"
                        appendTo="body"
                        (onChange)="onRubricaCompagnia($event.value)">
                        <ng-template let-a pTemplate="item">
                            <div class="flex flex-col">
                                <span>{{ a.ragione_sociale }}</span>
                                @if (a.piva) { <small class="text-gray-500">{{ a.piva }}</small> }
                            </div>
                        </ng-template>
                    </p-dropdown>
                    <small class="text-gray-500 block mt-1">Seleziona un’anagrafica per compilare ragione sociale, P.IVA e sede (e referente se presente). Se in rubrica ci sono visura/POS e sull’evento mancano, vengono allegati automaticamente.</small>
                </div>
                <div class="fld-grid three">
                    <div class="fld">
                        <label>* Spettacolo / Evento</label>
                        <input type="text" pInputText formControlName="evento" required />
                        @if (formEvento.get('evento')?.hasError('required') && (formEvento.get('evento')?.dirty || formEvento.get('evento')?.touched)) {
                            <small class="text-red-600 block font-medium">Lo Spettacolo / Evento è obbligatorio!</small>
                        }
                    </div>
                    <div class="fld">
                        <label>* Data inizio - Data fine</label>
                        <p-calendar placeholder="dd/mm/aaaa - dd/mm/aaaa" formControlName="dal_al" [showIcon]="true" selectionMode="range" appendTo="body"></p-calendar>
                        @if (formEvento.get('dal_al')?.hasError('required') && (formEvento.get('dal_al')?.dirty || formEvento.get('dal_al')?.touched)) {
                            <small class="text-red-600 block font-medium">La Data di Inizio e Fine sono obbligatorie!</small>
                        }
                    </div>
                    <div class="fld">
                        <label>* Ragione Sociale</label>
                        <input type="text" pInputText formControlName="ragione_sociale" required />
                        @if (formEvento.get('ragione_sociale')?.hasError('required') && (formEvento.get('ragione_sociale')?.dirty || formEvento.get('ragione_sociale')?.touched)) {
                            <small class="text-red-600 block font-medium">La Ragione Sociale è obbligatoria!</small>
                        }
                    </div>
                </div>

                <div class="fld-grid">
                    <div class="fld">
                        <label>* Partita IVA / Codice Fiscale</label>
                        <input type="text" pInputText formControlName="piva" required />
                        @if (formEvento.get('piva')?.hasError('required') && (formEvento.get('piva')?.dirty || formEvento.get('piva')?.touched)) {
                            <small class="text-red-600 block font-medium">La P.Iva / Cod. Fiscale sono obbligatori!</small>
                        }
                    </div>
                    <div class="fld">
                        <label>* Sede Legale</label>
                        <input type="text" pInputText formControlName="sede" required />
                        @if (formEvento.get('sede')?.hasError('required') && (formEvento.get('sede')?.dirty || formEvento.get('sede')?.touched)) {
                            <small class="text-red-600 block font-medium">La Sede Legale è obbligatoria!</small>
                        }
                    </div>
                </div>

                <span class="sec-subtitle">Referente</span>
                <div class="fld-grid three">
                    <div class="fld">
                        <label>* Cognome e Nome</label>
                        <input type="text" pInputText formControlName="anagrafica" required />
                        @if (formEvento.get('anagrafica')?.hasError('required') && (formEvento.get('anagrafica')?.dirty || formEvento.get('anagrafica')?.touched)) {
                            <small class="text-red-600 block font-medium">Il Cognome e Nome è obbligatorio!</small>
                        }
                    </div>
                    <div class="fld">
                        <label>* Email</label>
                        <input type="email" pInputText formControlName="email" required />
                        @if (formEvento.get('email')?.hasError('required') && (formEvento.get('email')?.dirty || formEvento.get('email')?.touched)) {
                            <small class="text-red-600 block font-medium">L'Email è obbligatoria!</small>
                        }
                        @if (formEvento.get('email')?.hasError('email') && (formEvento.get('email')?.dirty || formEvento.get('email')?.touched)) {
                            <small class="text-red-600 block font-medium">Inserire un'Email valida!</small>
                        }
                    </div>
                    <div class="fld">
                        <label>* Telefono</label>
                        <input type="tel" pInputText formControlName="telefono" required />
                        @if (formEvento.get('telefono')?.hasError('required') && (formEvento.get('telefono')?.dirty || formEvento.get('telefono')?.touched)) {
                            <small class="text-red-600 block font-medium">Il Numero di Telefono è obbligatorio!</small>
                        }
                        @if (formEvento.get('telefono')?.hasError('pattern') && (formEvento.get('telefono')?.dirty || formEvento.get('telefono')?.touched)) {
                            <small class="text-red-600 block font-medium">Inserire un Numero di Telefono valido!</small>
                        }
                    </div>
                </div>

                <span class="sec-subtitle">Documenti compagnia/organizzatore</span>
                <div class="doc-list">
                    @if ((evento?.visura_camerale || '').length > 0) {
                        <app-file-loaded [evento]="evento" [tipo]="'visura_camerale'" [file]="evento?.visura_camerale || ''" [title]="'Visura camerale'" [meta]="'caricata · clicca Apri per scaricare'" [status]="'caricato'" [tooltip]="'Rimuovi la visura camerale caricata'"></app-file-loaded>
                        <div class="visura-scadenza-row">
                            <label for="visura_scadenza">Scadenza visura</label>
                            <p-calendar
                                inputId="visura_scadenza"
                                [ngModel]="visuraScadenzaModel"
                                (ngModelChange)="onVisuraScadenza($event)"
                                [ngModelOptions]="{standalone: true}"
                                dateFormat="dd/mm/yy"
                                [showIcon]="true"
                                [showClear]="true"
                                appendTo="body"
                                placeholder="dd/mm/aaaa"
                                [styleClass]="'scadenza-calendar' + (isVisuraScaduta ? ' scaduto' : '')"
                            />
                        </div>
                    } @else {
                        <div class="doc-missing" [class.crit]="docsObbligatori">
                            <div class="doc-missing-info">                                
                                <div class="doc-info">
                                    <strong>Visura camerale</strong>
                                    <span class="doc-meta" [class.crit]="docsObbligatori">{{ docsObbligatori ? 'non caricato · obbligatorio' : 'non caricato' }}</span>
                                </div>
                            </div>
                            <app-file-upload [form]="formEvento" [control]="'visura_camerale'" [label]="''" [multiple]="false" [critical]="docsObbligatori" [accept]="'.doc,.docx,application/pdf,image/*'" [text]="'Trascina qui il file'"></app-file-upload>
                        </div>
                    }

                    @if ((evento?.duvri || '').length > 0) {
                        <app-file-loaded [evento]="evento" [tipo]="'duvri'" [file]="evento?.duvri || ''" [title]="'POS o autodichiarazione idoneità'" [meta]="'caricato · clicca Apri per scaricare'" [status]="'caricato'" [tooltip]="'Rimuovi il documento caricato'"></app-file-loaded>
                    } @else {
                        <div class="doc-missing" [class.crit]="docsObbligatori">
                            <div class="doc-missing-info">
                                <div class="doc-info">
                                    <strong>POS o autodichiarazione idoneità</strong>
                                    <span class="doc-meta" [class.crit]="docsObbligatori">{{ docsObbligatori ? 'non caricato · obbligatorio' : 'non caricato' }}</span>
                                </div>
                            </div>
                            <app-file-upload [form]="formEvento" [control]="'duvri_file'" [label]="''" [multiple]="false" [critical]="docsObbligatori" [accept]="'.doc,.docx,application/pdf,image/*'" [text]="'Trascina qui il file'"></app-file-upload>
                        </div>
                    }
                    @if (configurazione?.facsimile_autodichiarazione) {
                        <p class="text-sm mb-2">
                            <a href="#" class="underline" (click)="$event.preventDefault(); onDocumento(configurazione!.facsimile_autodichiarazione!)">Scarica facsimile autodichiarazione idoneità</a>
                        </p>
                    }

                    @for (scheda_tecnica of schede_tecniche; track scheda_tecnica.id) {
                        <app-file-loaded [evento]="evento" [documento]="scheda_tecnica" [tipo]="'scheda_tecnica'" [file]="scheda_tecnica.file || ''" [title]="'Scheda tecnica / Piano di produzione'" [meta]="'caricato · clicca Apri per scaricare'" [status]="'caricato'" [tooltip]="'Rimuovi la scheda tecnica'"></app-file-loaded>
                    }
                    <div class="doc-missing" [class.ok]="schede_tecniche.length > 0">
                        <div class="doc-missing-info">
                            <div class="doc-info">
                                <strong>Scheda tecnica / Piano di produzione</strong>
                                <span class="doc-meta">{{ schede_tecniche.length <= 0 ? 'opzionale' : 'aggiungi altri file' }}</span>
                            </div>
                        </div>
                        <app-file-upload [form]="formEvento" [control]="'scheda_tecnica'" [label]="''" [multiple]="true" [critical]="false" [accept]="'.doc,.docx,application/pdf,image/*'" [text]="'Trascina qui il file'"></app-file-upload>
                    </div>
                </div>

            </div>
        </section>

        <!-- §2 INFORMAZIONI -->
        <section class="sec info" [class.collapsed]="!openSections['info']">
            <div [ngClass]="secStato('info').cls" class="sec-head" (click)="toggleSec('info')">
                <h3>Informazioni aggiuntive</h3>
                <span class="stato-mini" [ngClass]="secStato('info').cls">{{ secStato('info').text }}</span>
                <span class="toggle">▾</span>
            </div>
            <div class="sec-body block-stack">
                <div class="flag-row">
                    <p-checkbox inputId="obbligatorieta" name="obbligatorieta" formControlName="obbligatorieta" value="Obbligatorieta" />
                    <label for="obbligatorieta">Documenti Compagnia e Subappalto obbligatori</label>
                </div>

                <div class="fld-grid three">
                    <div class="fld">
                        <label>* Blocco caricamento (ore)</label>
                        <input type="number" pInputNumber formControlName="blocco" required />
                        @if (formEvento.get('blocco')?.hasError('required') && (formEvento.get('blocco')?.dirty || formEvento.get('blocco')?.touched)) {
                            <small class="text-red-600 block font-medium">Il Blocco di caricamento è obbligatoria!</small>
                        }
                    </div>
                    <div class="fld">
                        <label>* Durata spettacolo (minuti)</label>
                        <p-inputNumber formControlName="durata" />
                        @if (formEvento.get('durata')?.hasError('required') && (formEvento.get('durata')?.dirty || formEvento.get('durata')?.touched)) {
                            <small class="text-red-600 block font-medium">La Durata è obbligatoria!</small>
                        }
                    </div>
                    <div class="fld">
                        <label>* Intervallo</label>
                        <div class="choice-group">
                            <div class="choice">
                                <p-radioButton name="intervallo" value="Si" inputId="intervallo_si" formControlName="intervallo" />
                                <label for="intervallo_si">Si</label>
                            </div>
                            <div class="choice">
                                <p-radioButton name="intervallo" value="No" inputId="intervallo_no" formControlName="intervallo" />
                                <label for="intervallo_no">No</label>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="fld">
                    <label>* Attività previste</label>
                    <div class="choice-group">
                        <div class="choice">
                            <p-checkbox inputId="attivita1" name="attivita" formControlName="attivita" value="Montaggio" />
                            <label for="attivita1">Montaggio</label>
                        </div>
                        <div class="choice">
                            <p-checkbox inputId="attivita2" name="attivita" formControlName="attivita" value="Prove" />
                            <label for="attivita2">Prove</label>
                        </div>
                        <div class="choice">
                            <p-checkbox inputId="attivita3" name="attivita" formControlName="attivita" value="Spettacolo" />
                            <label for="attivita3">Spettacolo</label>
                        </div>
                        <div class="choice">
                            <p-checkbox inputId="attivita4" name="attivita" formControlName="attivita" value="Smontaggio" />
                            <label for="attivita4">Smontaggio</label>
                        </div>
                    </div>
                    @if (formEvento.get('attivita')?.hasError('required') && (formEvento.get('attivita')?.dirty || formEvento.get('attivita')?.touched)) {
                        <small class="text-red-600 block font-medium">L'Attività prevista è obbligatoria!</small>
                    }
                </div>                

                <div class="fld-grid three">
                    <div class="fld">
                        <label>* Il pubblico può fare foto e/o video?</label>
                        <div class="choice-group">
                            <div class="choice">
                                <p-radioButton name="foto" value="Si" inputId="foto_si" formControlName="foto" />
                                <label for="foto_si">Si</label>
                            </div>
                            <div class="choice">
                                <p-radioButton name="foto" value="No" inputId="foto_no" formControlName="foto" />
                                <label for="foto_no">No</label>
                            </div>
                        </div>
                    </div>
                    <div class="fld">
                        <label>* Merchandising</label>
                        <div class="choice-group">
                            <div class="choice">
                                <p-radioButton name="merchandising" value="Si" inputId="merchandising_si" formControlName="merchandising" (onClick)="onMerchandising($event)" />
                                <label for="merchandising_si">Si</label>
                            </div>
                            <div class="choice">
                                <p-radioButton name="merchandising" value="No" inputId="merchandising_no" formControlName="merchandising" (onClick)="onMerchandising($event)" />
                                <label for="merchandising_no">No</label>
                            </div>
                        </div>
                        @if(formEvento.get('merchandising')?.value == 'Si') {
                            <div class="fld mt-3">
                                <label>* Nome ditta merchandising</label>
                                <input type="text" pInputText formControlName="merchandising_ditta" />
                            </div>
                            <div class="doc-list mt-3">
                                @if ((evento?.merchandising_visura || '').toString().length > 0) {
                                    <app-file-loaded [evento]="evento" [tipo]="'merchandising_visura'" [file]="evento?.merchandising_visura || ''" [title]="'Visura camerale ditta merchandising'" [meta]="'caricata · clicca Apri per scaricare'" [status]="'caricato'" [tooltip]="'Rimuovi la visura merchandising'"></app-file-loaded>
                                } @else {
                                    <div class="doc-missing" [class.crit]="!formEvento.get('merchandising_visura')?.value" [class.ok]="!!formEvento.get('merchandising_visura')?.value">
                                        <div class="doc-missing-info">
                                            <div class="doc-info">
                                                <strong>Visura camerale ditta merchandising</strong>
                                                <span class="doc-meta" [class.crit]="!formEvento.get('merchandising_visura')?.value">{{ formEvento.get('merchandising_visura')?.value ? 'file selezionato' : 'non caricato · obbligatorio' }}</span>
                                            </div>
                                        </div>
                                        <app-file-upload [form]="formEvento" [control]="'merchandising_visura'" [label]="''" [multiple]="false" [critical]="true" [accept]="'.doc,.docx,application/pdf,image/*'" [text]="'Trascina qui il file'"></app-file-upload>
                                    </div>
                                }
                            </div>
                            <div class="fld mt-3">
                                <label>Dati fatturazione</label>
                                <textarea pInputTextarea formControlName="merchandising_fatturazione" rows="3" placeholder="Ragione sociale, P.IVA, sede, IBAN…"></textarea>
                            </div>
                            <div class="fld mt-3">
                                <label>Email referente merchandising</label>
                                <input type="email" pInputText formControlName="merchandising_email" />
                                @if (formEvento.get('merchandising_email')?.hasError('email') && (formEvento.get('merchandising_email')?.dirty || formEvento.get('merchandising_email')?.touched)) {
                                    <small class="text-red-600 block font-medium">Inserire un'Email valida!</small>
                                }
                            </div>
                        }
                    </div>
                    <div class="fld">
                        <label>* Firmacopie / meet &amp; greet</label>
                        <div class="choice-group">
                            <div class="choice">
                                <p-radioButton name="firmacopie" value="Si" inputId="firmacopie_si" formControlName="firmacopie" (onClick)="onFirmacopie($event)" />
                                <label for="firmacopie_si">Si</label>
                            </div>
                            <div class="choice">
                                <p-radioButton name="firmacopie" value="No" inputId="firmacopie_no" formControlName="firmacopie" (onClick)="onFirmacopie($event)" />
                                <label for="firmacopie_no">No</label>
                            </div>
                        </div>
                        @if(formEvento.get('firmacopie')?.value == 'Si') {
                            <div class="fld mt-3">
                                <label>* Email Referente Firmacopie</label>
                                <input type="email" pInputText formControlName="firmacopie_email" />
                                @if (formEvento.get('firmacopie_email')?.hasError('required') && (formEvento.get('firmacopie_email')?.dirty || formEvento.get('firmacopie_email')?.touched)) {
                                    <small class="text-red-600 block font-medium">L'Email del Referente è obbligatoria!</small>
                                }
                                @if (formEvento.get('firmacopie_email')?.hasError('email') && (formEvento.get('firmacopie_email')?.dirty || formEvento.get('firmacopie_email')?.touched)) {
                                    <small class="text-red-600 block font-medium">Inserire un'Email valida!</small>
                                }
                            </div>
                        }
                    </div>
                </div>
            </div>
        </section>

        <!-- §3 PERSONALE -->
        <section class="sec personale" [class.collapsed]="!openSections['personale']">
            <div [ngClass]="secStato('personale').cls" class="sec-head" (click)="toggleSec('personale')">
                <h3>Personale</h3>
                <span class="stato-mini" [ngClass]="secStato('personale').cls">{{ secStato('personale').text }}</span>
                <span class="toggle">▾</span>
            </div>
            <div class="sec-body block-stack">
                <app-personale-accrediti-backoffice [personale]="evento?.personale ?? emptyList" [evento]="evento" />

                <div class="fld">
                    <label>* Tutti i membri del personale sono muniti di pass identificativo?</label>
                    <div class="choice-group">
                        <div class="choice">
                            <p-radioButton inputId="pass_compagnia_si" value="Si" formControlName="pass_compagnia" (ngModelChange)="onPassCompagnia($event)" />
                            <label for="pass_compagnia_si">Si</label>
                        </div>
                        <div class="choice">
                            <p-radioButton inputId="pass_compagnia_no" value="No" formControlName="pass_compagnia" (ngModelChange)="onPassCompagnia($event)" />
                            <label for="pass_compagnia_no">No</label>
                        </div>
                    </div>
                </div>

                @if(formEvento.get('pass_compagnia')?.value == 'Si') {
                    <div class="doc-list">
                        @if ((evento?.pass || '').length > 0) {
                            <app-file-loaded [evento]="evento" [tipo]="'pass_compagnia'" [file]="evento?.pass || ''" [title]="'Facs simile pass compagnia'" [meta]="'caricato · clicca Apri per scaricare'" [status]="'caricato'" [tooltip]="'Rimuovi il Facs Simile del Pass compagnia'"></app-file-loaded>
                        } @else {
                            <div class="doc-missing crit">
                                <div class="doc-missing-info">
                                    <div class="doc-info">
                                        <strong>Facs simile pass compagnia</strong>
                                        <span class="doc-meta crit">non caricato · obbligatorio</span>
                                    </div>
                                </div>
                                <app-file-upload #uploadPass [form]="formEvento" [control]="'pass_compagnia_file'" [label]="''" [multiple]="false" [critical]="true" [accept]="'.doc,.docx,application/pdf,image/*'" [text]="'Trascina qui il file'"></app-file-upload>
                            </div>
                        }
                    </div>
                }
            </div>

        </section>

        <!-- §4 SUBAPPALTI -->
        <section class="sec subappalti" [class.collapsed]="!openSections['subappalti']">
            <div [ngClass]="secStato('subappalti').cls" class="sec-head" (click)="toggleSec('subappalti')">
                <h3>Subappalti</h3>
                <span class="stato-mini" [ngClass]="secStato('subappalti').cls">{{ secStato('subappalti').text }}</span>
                <span class="toggle">▾</span>
            </div>
            <div class="sec-body">
                <app-subappalti-accrediti-backoffice [subappalti]="evento?.subappalti ?? emptyList" [evento]="evento" />

            </div>
        </section>

        <!-- §5 AGIBILITÀ E CERTIFICAZIONI -->
        <section class="sec impianti" [class.collapsed]="!openSections['impianti']">
            <div [ngClass]="secStato('impianti').cls" class="sec-head" (click)="toggleSec('impianti')">
                <h3>Agibilità e Certificazioni</h3>
                <div class="sec-head-chips">
                    @for (chip of secChips('impianti'); track chip.text) {
                        <span class="stato-mini" [ngClass]="chip.cls">{{ chip.text }}</span>
                    }
                </div>
                <span class="toggle">▾</span>
            </div>
            <div class="sec-body block-stack">
                <span class="sec-subtitle" style="border-top:0;padding-top:0;margin-top:0">Agibilità INPS</span>
                <div class="doc-list">
                    @for (agibilita of agibilita_inps; track agibilita.id) {
                        <app-file-loaded [evento]="evento" [documento]="agibilita" [tipo]="'inps'" [file]="agibilita.file || ''" [title]="'Certificato di agibilità INPS'" [meta]="'caricato · clicca Apri per scaricare'" [status]="'caricato'" [tooltip]="'Rimuovi agibilità INPS'"></app-file-loaded>
                    }
                    <div class="doc-missing" [class.ok]="agibilita_inps.length > 0">
                        <div class="doc-missing-info">
                            <div class="doc-info">
                                <strong>Certificato/i di agibilità INPS</strong>
                                <span class="doc-meta">{{ agibilita_inps.length <= 0 ? 'opzionale' : 'aggiungi altri file' }}</span>
                            </div>
                        </div>
                        <app-file-upload [form]="formEvento" [control]="'agibilita_inps_file'" [label]="''" [multiple]="true" [critical]="false" [accept]="'.doc,.docx,application/pdf,image/*'" [text]="'Trascina qui il file'"></app-file-upload>
                    </div>
                </div>

                <span class="sec-subtitle">Montaggio</span>
                <div class="flag-row">
                    <p-checkbox inputId="montaggio" name="montaggio" formControlName="montaggio" value="montaggio" (onChange)="onCertificazioneImpianti($event)" />
                    <label for="montaggio">Corretto montaggio</label>
                </div>
                <div class="doc-list">
                    @for (file of montaggio; track file.id) {
                        <app-file-loaded [evento]="evento" [documento]="file" [tipo]="'montaggio'" [file]="file.file || ''" [title]="'Documento di montaggio'" [meta]="'caricato · clicca Apri per scaricare'" [status]="'caricato'" [tooltip]="'Rimuovi documento di montaggio'"></app-file-loaded>
                    }
                    <div class="doc-missing" [class.crit]="hasMontaggio && montaggio.length <= 0" [class.ok]="montaggio.length > 0">
                        <div class="doc-missing-info">
                            <div class="doc-info">
                                <strong>Documenti di montaggio</strong>
                                <span class="doc-meta" [class.crit]="hasMontaggio && montaggio.length <= 0">{{ montaggio.length <= 0 ? (hasMontaggio ? 'non caricato · obbligatorio' : 'opzionale') : 'aggiungi altri file' }}</span>
                            </div>
                        </div>
                        <app-file-upload [form]="formEvento" [control]="'montaggio_file'" [label]="''" [multiple]="true" [critical]="hasMontaggio && montaggio.length <= 0" [accept]="'.doc,.docx,application/pdf,image/*'" [text]="'Trascina qui il file'"></app-file-upload>
                    </div>
                </div>

                <span class="sec-subtitle">Certificazioni impianti</span>
                <div class="matrice">
                    
                    <div class="matrice-row">
                        <div class="label-mat" [class.attivo]="hasImpianto('non_presenti')">
                            Impianti non presenti
                            <span class="sub">nessun impianto portato dalla compagnia</span>
                        </div>
                        <div class="matrice-toggle">
                            <button type="button" class="matrice-opt si" [class.active]="hasImpianto('non_presenti')" (click)="setImpianto('non_presenti', 'Si')">Si</button>
                            <button type="button" class="matrice-opt" [class.active]="!hasImpianto('non_presenti')" (click)="setImpianto('non_presenti', 'No')">No</button>
                        </div>
                    </div>

                    @for (item of impiantiOptions; track item.value) {
                        <div class="matrice-row" [class.disabled]="hasImpianto('non_presenti')">
                            <div class="label-mat" [class.attivo]="hasImpianto(item.value) && docsByTipo(item.value).length > 0" [class.crit]="hasImpianto(item.value) && docsByTipo(item.value).length === 0">
                                {{ item.label }}
                                @if (hasImpianto(item.value)) {
                                    <span class="sub" [class.crit]="docsByTipo(item.value).length === 0">{{ docsByTipo(item.value).length }} {{ docsByTipo(item.value).length === 1 ? 'documento caricato' : 'documenti caricati' }}</span>
                                }
                            </div>
                            <div class="matrice-toggle">
                                <button type="button" class="matrice-opt si" [class.active]="hasImpianto(item.value)" [disabled]="hasImpianto('non_presenti')" (click)="setImpianto(item.value, 'Si')">Si</button>
                                <button type="button" class="matrice-opt" [class.active]="!hasImpianto(item.value)" [disabled]="hasImpianto('non_presenti')" (click)="setImpianto(item.value, 'No')">No</button>
                            </div>
                        </div>
                    }

                    <div class="matrice-row" [class.disabled]="hasImpianto('non_presenti')">
                        <div class="label-mat" [class.attivo]="hasImpianto('altro') && docsByTipo('altro').length > 0" [class.crit]="hasImpianto('altro') && docsByTipo('altro').length === 0">
                            Altro
                            @if (hasImpianto('altro')) {
                                <span class="sub" [class.crit]="docsByTipo('altro').length === 0">{{ docsByTipo('altro').length }} {{ docsByTipo('altro').length === 1 ? 'documento caricato' : 'documenti caricati' }}</span>
                            } @else {
                                <span class="sub">certificazione non in elenco</span>
                            }
                        </div>
                        <div class="matrice-toggle">
                            <button type="button" class="matrice-opt si" [class.active]="hasImpianto('altro')" [disabled]="hasImpianto('non_presenti')" (click)="setImpianto('altro', 'Si')">Si</button>
                            <button type="button" class="matrice-opt" [class.active]="!hasImpianto('altro')" [disabled]="hasImpianto('non_presenti')" (click)="setImpianto('altro', 'No')">No</button>
                        </div>
                    </div>
                </div>

                @if (!hasImpianto('non_presenti')) {
                    @for (item of impiantiOptions; track item.value) {
                        @if (hasImpianto(item.value)) {
                            <div class="impianto-block">
                                <div class="impianto-block-head">
                                    <h4>{{ item.label }} · certificati richiesti</h4>
                                    <span class="req">{{ docsByTipo(item.value).length > 0 ? docsByTipo(item.value).length + ' documenti' : 'documento richiesto' }}</span>
                                </div>
                                <div class="doc-list">
                                    @for (doc of docsByTipo(item.value); track doc.id) {
                                        <app-file-loaded [evento]="evento" [documento]="doc" [tipo]="item.value" [file]="doc.file || ''" [title]="'Documenti ' + item.label" [meta]="'caricato · clicca Apri per scaricare'" [status]="'caricato'" [tooltip]="'Rimuovi documento'"></app-file-loaded>
                                    }
                                    <div class="doc-missing" [class.crit]="docsByTipo(item.value).length <= 0">
                                        <div class="doc-missing-info">
                                            <div class="doc-info">
                                                <strong>Documenti {{ item.label }}</strong>
                                                <span class="doc-meta" [class.crit]="docsByTipo(item.value).length <= 0">{{ docsByTipo(item.value).length <= 0 ? 'non caricato' : 'aggiungi altri file' }}</span>
                                            </div>
                                        </div>
                                        <app-file-upload [form]="formEvento" [control]="item.control" [label]="''" [multiple]="true" [critical]="docsByTipo(item.value).length <= 0" [accept]="'.doc,.docx,application/pdf,image/*'" [text]="'Trascina qui il file'"></app-file-upload>
                                    </div>
                                </div>
                            </div>
                        }
                    }

                    @if (hasImpianto('altro')) {
                        <div class="impianto-block">
                            <div class="impianto-block-head">
                                <h4>Altro · certificati richiesti</h4>
                                <span class="req">{{ docsByTipo('altro').length > 0 ? docsByTipo('altro').length + ' documenti' : 'documento richiesto' }}</span>
                            </div>
                            <div class="fld">
                                <label>* Descrizione certificazione/i</label>
                                <input type="text" pInputText formControlName="certificazione_impianti_extra" required />
                                @if (formEvento.get('certificazione_impianti_extra')?.hasError('required') && (formEvento.get('certificazione_impianti_extra')?.dirty || formEvento.get('certificazione_impianti_extra')?.touched)) {
                                    <small class="text-red-600 block font-medium">La certificazione dell'impianto è obbligatoria!</small>
                                }
                            </div>
                            <div class="doc-list">
                                    @for (doc of docsByTipo('certificazione_impianti_extra'); track doc.id) {
                                    <app-file-loaded [evento]="evento" [documento]="doc" [tipo]="'certificazione_impianti_extra'" [file]="doc.file || ''" [title]="'Certificazione impianti — Altro'" [meta]="'caricato · clicca Apri per scaricare'" [status]="'caricato'" [tooltip]="'Rimuovi documento'"></app-file-loaded>
                                }
                                <div class="doc-missing" [class.crit]="docsByTipo('altro').length <= 0">
                                    <div class="doc-missing-info">
                                        <div class="doc-info">
                                            <strong>Documenti certificazione — Altro</strong>
                                            <span class="doc-meta" [class.crit]="docsByTipo('altro').length <= 0">{{ docsByTipo('altro').length <= 0 ? 'non caricato' : 'aggiungi altri file' }}</span>
                                        </div>
                                    </div>
                                    <app-file-upload [form]="formEvento" [control]="'certificazione_impianti_extra_file'" [label]="''" [multiple]="true" [critical]="docsByTipo('altro').length <= 0" [accept]="'.doc,.docx,application/pdf,image/*'" [text]="'Trascina qui il file'"></app-file-upload>
                                </div>
                            </div>
                        </div>
                    }
                }

                @if (formEvento.get('certificazione_impianti')?.hasError('required') && (formEvento.get('certificazione_impianti')?.dirty || formEvento.get('certificazione_impianti')?.touched)) {
                    <small class="text-red-600 block font-medium">La certificazione degli impianti è obbligatoria!</small>
                }

                <div class="ac-archivio-upload">
                    <span class="sec-subtitle">Carica documentazione completa (cartella)</span>
                    <p class="ac-note-hint">Tutti i file della cartella vengono salvati in griglia come documenti di tipo archivio.</p>
                    <input #archivioFolder type="file" hidden webkitdirectory multiple (change)="onArchivioFolder($event)" />
                    <button type="button" class="acc-btn" [disabled]="archivioLoading || !evento?.id" (click)="archivioFolder.click()">
                        <i class="bi bi-folder2-open"></i>
                        {{ archivioLoading ? 'Caricamento…' : 'Carica cartella' }}
                    </button>
                </div>

                <app-documenti-accrediti-backoffice [documenti]="documenti || []" [evento]="evento" />

            </div>
        </section>

        <!-- §6 DIRITTI D'AUTORE -->
        <section class="sec diritti" [class.collapsed]="!openSections['diritti']">
            <div [ngClass]="secStato('diritti').cls" class="sec-head" (click)="toggleSec('diritti')">
                <h3>Diritti d'autore</h3>
                <span class="stato-mini" [ngClass]="secStato('diritti').cls">{{ secStato('diritti').text }}</span>
                <span class="toggle">▾</span>
            </div>
            <div class="sec-body block-stack">
                <div class="fld" formArrayName="collecting">
                    <label>Collecting di riferimento</label>
                    @for (g of collectingArray.controls; track g; let i = $index) {
                        <div class="fld-grid two mt-3" [formGroupName]="i">
                            <div class="fld">
                                <label>Nome collecting</label>
                                <input type="text" pInputText formControlName="nome" />
                                @if (g.get('nome')?.hasError('required') && (g.get('nome')?.dirty || g.get('nome')?.touched)) {
                                    <small class="text-red-600 block font-medium">Il nome è obbligatorio!</small>
                                }
                            </div>
                            <div class="fld">
                                <label>% repertorio tutelato</label>
                                <div class="flex gap-2 items-start">
                                    <input type="number" pInputText formControlName="percentuale" min="0" max="100" class="flex-1" />
                                    <button type="button" class="acc-btn acc-btn-ghost" (click)="removeCollecting(i)">Rimuovi</button>
                                </div>
                                @if (g.get('percentuale')?.invalid && (g.get('percentuale')?.dirty || g.get('percentuale')?.touched)) {
                                    <small class="text-red-600 block font-medium">Inserire una percentuale tra 0 e 100!</small>
                                }
                            </div>
                        </div>
                    }
                    <button type="button" class="acc-btn self-start mt-3" (click)="addCollecting()">+ Aggiungi collecting</button>
                </div>
                <p class="text-sm mt-4" style="color: var(--acc-ink-mute); line-height: 1.5; text-transform: none; letter-spacing: 0;">
                    La compagnia garantisce che il direttore musicale, o altro referente incaricato, trasmetterà a ciascuna collecting di riferimento il programma musicale (borderò), nei tempi e modalità richieste.
                </p>
            </div>
        </section>

        <!-- §7 MEZZI -->
        <section class="sec mezzi" [class.collapsed]="!openSections['mezzi']">
            <div [ngClass]="secStato('mezzi').cls" class="sec-head" (click)="toggleSec('mezzi')">
                <h3>Mezzi di trasporto</h3>
                <span class="stato-mini" [ngClass]="secStato('mezzi').cls">{{ secStato('mezzi').text }}</span>
                <span class="toggle">▾</span>
            </div>
            <div class="sec-body">
                <app-mezzi-trasporto-accrediti-backoffice [mezzi]="evento?.mezzi ?? emptyList" [evento]="evento" />
            </div>
        </section>

        <div class="scheda-actions">
            <div>
                <button class="acc-btn acc-btn-primary" type="submit">Modifica</button>
            </div>
            <div>
                <p-confirmPopup #delete>
                    <ng-template pTemplate="headless" let-message>
                        <div class="border-round p-3">
                            <span class="text-base">{{ message.message }}</span>
                            <div class="acc-actions" style="margin-top: 12px;">
                                <button type="button" class="acc-btn acc-btn-danger flex-1" (click)="onDelete()">Elimina</button>
                                <button type="button" class="acc-btn acc-btn-ghost flex-1" (click)="onAnnulla()">Annulla</button>
                            </div>
                        </div>
                    </ng-template>
                </p-confirmPopup>
                <button class="acc-btn acc-btn-danger" type="button" (click)="onDeletePopup($event)">Elimina</button>
            </div>
        </div>
    </form>
</section>
